module.exports = __webpack_public_path__ + "img/IT0000317158402.b592cde3.png";